module.exports = __webpack_public_path__ + "static/media/park2.ef25da07.png";